import { useCallback } from "react";
import { useAtom } from "jotai";
import type { Currency } from "../types";
import { SUPPORTED_APP_CURRENCIES } from "../lib/currency";
import { currentCurrencyAtom } from "../store/currencyAtoms";

export function useCurrentCurrency() {
  const [currency, setCurrencyState] = useAtom(currentCurrencyAtom);

  const setCurrency = useCallback(
    (next: Currency) => {
      if (!SUPPORTED_APP_CURRENCIES.includes(next)) return;
      setCurrencyState(next);
    },
    [setCurrencyState],
  );

  return { currency, setCurrency };
}
